import store from 'store'
import { redirect } from 'redux-first-router'
import bugsnag from 'bugsnag'
import {
  setToken,
  accessToken,
  refreshToken,
  removeAccessToken,
  removeRefreshToken,
  invalidTokenString,
  setInvalidAccessToken
} from 'utils/tokens'
import {
  setRedirectLocation,
} from 'utils/Client/redirects'

import { SERVER_ERROR, TECHNICAL_GLITCH_ERROR } from 'utils/errorTypes'
import {
  BLACK_DIAMOND_API_PATH,
  BOX_API_PATH,
  SALESFORCE_API_PATHS,
} from 'utils/Client/thirdPartyApiPaths'

import actions from 'actions/index'

const {
  setError,
  goErrorPage,
  setBlackDiamondError,
  setBoxError,
  setIsLoading,
  setRedirection
} = actions

export const handleAuthError = (error, revokeAuthTokens = null) => {
  bugsnag.notify(error)

  if (revokeAuthTokens) {
    logOut(revokeAuthTokens)
  } else {
    throw error
  }
}

export const digitalSignInUrl = `${process.env.REACT_APP_DIGITAL_CLIENT_HOST}/people/sign_out`

export const redirectToLogin = () => window.location = digitalSignInUrl

export const logOut = async (revokeAuthTokens) => {
  const missingAccessToken = accessToken() == null
  const accessTokenInvalid = accessToken() === invalidTokenString
  if (!missingAccessToken && !accessTokenInvalid) {
    await revokeAuthTokens()
  }

  const { location: { type, payload } } = store.getState()

  removeAccessToken()
  removeRefreshToken()

  const location = {
    type,
    payload
  }
  setRedirectLocation(location)
  store.dispatch(setRedirection(true))
  redirectToLogin()
}

const setNewTokens = (newTokens) => {
  const accessToken = newTokens.access_token
  const refreshToken = newTokens.refresh_token
  setToken('accessToken', accessToken, 'local')
  setToken('refreshToken', refreshToken, 'local')
}

const refreshTokens = async (retrieveNewTokens) => {
  const newTokens = await retrieveNewTokens()
  setNewTokens(newTokens)
}

export const attemptRequestAfterRefresh = async (endpoint, method, options, refreshCallbacks) => {
  const { revokeAuthTokens, retrieveNewTokens, travellerApiRequest } = refreshCallbacks
  setInvalidAccessToken()

  try {
    await refreshTokens(retrieveNewTokens)
    travellerApiRequest(endpoint, method, options)
  } catch (e) {
    logOut(revokeAuthTokens)
  }
}

export const ableToReattemptRequest = () => {
  const refreshRequestFailed = accessToken() === invalidTokenString
  const refreshTokenIsMissing = refreshToken() == null

  return !refreshTokenIsMissing && !refreshRequestFailed
}

export const handleThirdPartyError = (endpoint, error) => {
  if (endpoint.includes(BLACK_DIAMOND_API_PATH)) {
    return handleBlackDiamondError(error)
  } else if (endpoint.includes(BOX_API_PATH)) {
    return handleBoxError(error)
  } else if (SALESFORCE_API_PATHS.includes(endpoint)) {
    return handleSalesforceError(error)
  } else {
    throw error
  }
}

export const handleBlackDiamondError = (error) => {
  bugsnag.notify(error)
  store.dispatch(setBlackDiamondError())
  store.dispatch(setIsLoading(false))
}

export const handleSalesforceError = (error) => {
  bugsnag.notify(error)
  store.dispatch(setError(TECHNICAL_GLITCH_ERROR))
  store.dispatch(redirect(goErrorPage()))
  store.dispatch(setIsLoading(false))
}

export const handleBoxError = (error) => {
  bugsnag.notify(error)
  store.dispatch(setBoxError())
}

export const handleGeneralError = (error, redirectGeneralErrorPage) => {
  bugsnag.notify(error)
  store.dispatch(setIsLoading(false))

  if (redirectGeneralErrorPage) {
    store.dispatch(setError(SERVER_ERROR))
    store.dispatch(redirect(goErrorPage()))
  } else {
    throw error
  }
}

export default attemptRequestAfterRefresh



// WEBPACK FOOTER //
// ./src/utils/Client/apiErrorHandler.js